import { GUMLET_BASE_URL } from "constants/index";
import { logger } from "helpers/logger";
/* eslint-disable import/prefer-default-export */

export const toVideoCDNUrl = (newUrl: string): string => {
  if (!newUrl) return "";

  try {
    const pathname = newUrl.startsWith("http") ? new URL(newUrl).pathname : `/${newUrl}`;
    const key = pathname.replace(/^\/+/, "");

    return `${GUMLET_BASE_URL}${key}?h=720`;
  } catch (error) {
    logger.error("Error in toVideoCDNUrl:", error);
    return "";
  }
};
